import script from "./TransactionsLinks.vue?vue&type=script&setup=true&lang=js"
export * from "./TransactionsLinks.vue?vue&type=script&setup=true&lang=js"

import "./TransactionsLinks.vue?vue&type=style&index=0&id=1af1a692&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1af1a692"]])

export default __exports__